import { component } from 'picoapp';

export default component(async (node, ctx) => {
  const form = node.querySelector('#cart-page-form');

  if (form) {
    form.addEventListener('submit', (e) => {
      if (!form.querySelector('#accept_terms')?.checked) {
        e.preventDefault();
        ctx.emit('cart:request:terms', ({ keepBgLocked: false }));
      }
    });

    ctx.on('cart:terms:accepted', () => {
      form.querySelector('#accept_terms').checked = true;
      form.submit();
    });
  }
});
